import { TFunction } from "i18next";

import { MANUAL_KYC_STATUSES, ManualKycStatus } from "types/kycStatus";

const KYC_STATUS_LABEL_KEYS: Record<ManualKycStatus, string> = {
  none: "kycStatusNone",
  pending: "kycStatusPending",
  approved: "kycStatusApproved",
  rejected: "kycStatusRejected",
  expired: "kycStatusExpired",
  requiresReview: "kycStatusRequiresReview",
};

export const normalizeKycStatus = (status?: string): ManualKycStatus => {
  const normalizedStatus = status?.trim().toLowerCase();
  const legacyStatusAliases: Record<string, ManualKycStatus> = {
    processing: "pending",
    completed: "approved",
    requires_review: "requiresReview",
  };
  const match = MANUAL_KYC_STATUSES.find(
    (item) => item.toLowerCase() === normalizedStatus,
  );

  return (
    match ??
    (normalizedStatus ? legacyStatusAliases[normalizedStatus] : undefined) ??
    "none"
  );
};

export const getKycStatusLabel = (status: ManualKycStatus, t: TFunction) =>
  t(KYC_STATUS_LABEL_KEYS[status]);

export const KYC_STATUS_OPTIONS = MANUAL_KYC_STATUSES.map((value) => ({
  value,
  labelKey: KYC_STATUS_LABEL_KEYS[value],
}));
